/* eslint-disable react/jsx-props-no-spreading */
import * as React from "react";

const NoSearchIconJobFilters = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
		<path
			fill="#8C8594"
			d="M9 .667A8.336 8.336 0 0 0 .667 9c0 4.6 3.733 8.333 8.333 8.333S17.334 13.6 17.334 9 13.6.667 9 .667Zm.834 14.166H8.167v-1.666h1.667v1.666Zm1.725-6.458-.75.767c-.417.425-.717.808-.867 1.408a3.824 3.824 0 0 0-.108.95H8.167v-.417a3.331 3.331 0 0 1 .975-2.358l1.033-1.05c.384-.367.567-.917.459-1.5A1.659 1.659 0 0 0 9.475 4.9a1.68 1.68 0 0 0-2.058 1.058c-.1.309-.358.542-.683.542h-.25a.722.722 0 0 1-.684-.933 3.34 3.34 0 0 1 2.692-2.359c1.267-.2 2.475.459 3.225 1.5.983 1.359.692 2.817-.158 3.667Z"
		/>
	</svg>
);
export default NoSearchIconJobFilters;
